import { AntButton } from '@/common/ant-components/AntButton';
import DraggableModal from '@/common/ant-components/DraggableModal';
import { useNavigationHistory } from '@/common/navigation-history';
import { returnLinks } from '@/common/navigation-history/data';
import ItemForm from '@/components/forms/master/inventory/item/ItemForm';
import { useTransactionContext } from '@/context/TransactionContext';
import {
  isDiamondStoneRow,
  isDiamondStoneType,
  useDiamondStoneModal,
} from '@/pages/transaction/reuse/helpers/diamondStone';
import {
  formatNumber,
  formatNumberWithComma,
} from '@/utils/formula/CodeWindow';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import GlobalModal from '@/utils/modal/Modal';
import { BACK_ROUTES_PATH } from '@/utils/routerPath/route-path';
import CustomSelect from '@/utils/search/Search';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Modal, Spin, Table } from 'antd';
import Cookies from 'js-cookie';
import { createRef, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const DynamicTransactionTableSO = ({
  loading,
  columns,
  tableData,
  handleAddRow,
  handleItemSelect,
  renderSummary,
  showItemList,
  baseUrl,
  editUrl,
  handlePurchaseItemClick,
  refreshTable,
  form,
  from,
  showDisabledData,
  selectRefs,
  selectRef,
  discountRef,
  selectedData,
  isPurchaseFromModal,
  purchaseTableData,
  onItemSearch,
  onItemPopupScroll,
  onItemOpenChange,
  itemFetching = false,
  enableDiamondStone = false,
}) => {
  const {
    selectedItems,
    setSelectedItems,
    selectedRowKey,
    // setHiddenValueChange,
    hiddenValueChange,
    setSelectedRowKey,
  } = useTransactionContext();
  const navigate = useNavigate();
  const { openDiamondStone, openDiamondStoneForRow } = useDiamondStoneModal();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const formD = Form.useFormInstance();

  const firstRowRef = useRef(null);
  const lastRowRef = useRef(null);

  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);
  const [deletereferenceId, setDeleteReferenceId] = useState({});
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  const [scrollY, setScrollY] = useState(400); // Default height

  useEffect(() => {
    // Function to calculate dynamic table height
    const updateTableHeight = () => {
      const windowHeight = window.innerHeight;
      const tableOffset = 560; // Adjust based on header, padding, etc.

      const updatedHeight = Math.max(windowHeight - tableOffset, 100);
      setScrollY(updatedHeight);
    };
    updateTableHeight(); // Initial height set
    window.addEventListener('resize', updateTableHeight); // Update on resize
    return () => window.removeEventListener('resize', updateTableHeight);
  }, []);

  const handleAddClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const history = useNavigationHistory();

  const location = useLocation();

  const [yesNo, setYesNo] = useState(false);

  const noRef = useRef();
  const yesRef = useRef();

  const itemListWithSavedItems = (() => {
    const rows = showItemList || [];
    const known = new Set(rows.map((item) => item?.referenceId));
    const saved = [];
    (tableData || []).forEach((row) => {
      const itemId =
        row?.item || row?.itemId || row?.finalData?.detailsJson?.[0]?.itemId;
      if (!itemId || !row?.itemName || known.has(itemId)) return;
      known.add(itemId);
      saved.push({
        referenceId: itemId,
        name: row.itemName,
        itemTypeName: row?.itemTypeName || row?.itemType,
        isSavedRowItem: true,
      });
    });
    return saved.length ? [...saved, ...rows] : rows;
  })();

  const modifiedColumns = columns?.map((column) => {
    switch (column?.key) {
      case 'SN':
        return {
          ...column,
          render: (_, __, index) => index + 1,
        };
      case 'item':
        return {
          ...column,
          render: (_, rowData, index) => {
            formD?.setFieldValue(
              `item_name_sales_order_${index}`,
              rowData?.item ||
                rowData?.itemName ||
                (index > 0 ? tableData?.[index - 1]?.itemName : undefined),
            );

            const currentItemName = tableData?.[index - 1]?.itemName;

            const sortedItemList = [
              ...itemListWithSavedItems.filter(
                (item) => item.name === currentItemName,
              ),
              ...itemListWithSavedItems.filter(
                (item) => item.name !== currentItemName,
              ),
            ];

            const isFirstIndex = index === 0;

            if (!selectRefs.current[index]) {
              selectRefs.current[index] = createRef();
            }

            return (
              <Form.Item
                name={`item_name_sales_order_${index}`}
                noStyle
                rules={[
                  {
                    required: isFirstIndex,
                    message: '',
                  },
                ]}
              >
                <CustomSelect
                  style={{ width: '100%' }}
                  placeholder="Select Item"
                  selectRef={selectRefs.current[index]}
                  value={rowData?.item || rowData?.itemName || undefined}
                  onChange={(value, option, e) => {
                    handleItemSelect(value, index, option?.itemName);
                    showDisabledData &&
                      setSelectedItems((prevSelected) => [
                        ...prevSelected,
                        value,
                      ]);

                    // if (option?.itemName) {
                    //   form.setFieldsValue({
                    //     hidden_valueChange: true,
                    //   });
                    // }
                    // setHiddenValueChange(true);

                    if (
                      enableDiamondStone &&
                      isDiamondStoneType(option?.itemType)
                    ) {
                      openDiamondStone(
                        rowData?.id || rowData?.codeWindowId,
                        option,
                      );
                      return;
                    }
                    navigate(
                      `/${baseUrl}/${rowData?.id || rowData?.codeWindowId}`,
                    );
                  }}
                  onKeyDown={(e) => {
                    if (e.code === 'ArrowLeft' && index === 0) {
                      e.preventDefault();
                      selectRef.current?.focus();
                    }
                    if (
                      e.key === '+' ||
                      e.code === 'Equal' ||
                      e.code === 'NumpadAdd'
                    ) {
                      e.preventDefault();
                      handleAddClick();
                    }
                    if (e.altKey && e.code === 'KeyD') {
                      e.preventDefault();
                      discountRef?.current?.focus();
                    }
                    if (e.code === 'F10') {
                      e.preventDefault();
                      formD?.submit();
                    }
                    if (e.altKey && e.code === 'ArrowUp') {
                      firstRowRef.current.focus();
                    }
                    if (e.altKey && e.code === 'ArrowDown') {
                      lastRowRef.current.focus();
                    }

                    if (e.code === 'Escape') {
                      e.preventDefault();
                      if (!hiddenValueChange) {
                        target
                          ? navigate(-1)
                          : isRedirectPath
                            ? navigate(isRedirectPath)
                            : navigate(-1);
                        return;
                      } else {
                        setYesNo(true);
                        setTimeout(() => {
                          noRef?.current?.focus();
                        }, 100);
                      }
                    }
                  }}
                  disabled={
                    !!rowData?.itemId ||
                    !!rowData?.itemName ||
                    (location.pathname.includes('/receive/refine/')
                      ? !selectedData?.ledger?.length
                      : false)
                  }
                  options={sortedItemList?.map((item) => ({
                    key: item.referenceId,
                    label: item.name,
                    value: item.referenceId,
                    itemName: item.name,
                    itemType: item?.typeName || item?.itemTypeName,
                    disabled:
                      !item?.isSavedRowItem &&
                      item?.barCode !== 'yes' &&
                      selectedItems.includes(item.referenceId),
                  }))}
                  filterSort={() => {}}
                  {...(onItemSearch && {
                    onSearch: onItemSearch,
                    onPopupScroll: onItemPopupScroll,
                    onDropdownVisibleChange: onItemOpenChange,
                    filterOption: false,
                    loading: itemFetching,
                    notFoundContent: itemFetching ? (
                      <Spin size="small" />
                    ) : undefined,
                  })}
                  onAddClick={handleAddClick}
                />
              </Form.Item>
            );
          },
        };

      case 'subTotal':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.netAmount || 0),
        };

      case 'code':
        return {
          ...column,
          render: (_, rowData) => rowData?.itemCode || rowData?.code,
        };
      case 'purity':
        return {
          ...column,
          render: (_, rowData) =>
            rowData?.purity
              ? Number((rowData?.purity * 24) / 100)?.toLocaleString()
              : 0,
        };

      case 'gwt':
        return {
          ...column,
          render: (_, rowData) => rowData?.grossWeight || 0,
        };
      case 'diamondWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.diamondWeight || 0,
        };

      case 'stoneWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.stoneWeight || 0,
        };

      case 'nwt':
        return {
          ...column,
          render: (_, rowData) => rowData?.netWeight || 0,
        };
      case 'vatAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.vatAmount) || 0,
        };

      case 'taxableAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.taxableAmount) || 0,
        };
      case 'discountAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.discountAmount) || 0,
        };
      case 'taxAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.taxAmount) || 0,
        };

      case 'netAmountWithTax':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.netAmountWithTaxPlusVat) || 0,
        };

      case 'wtInTola':
        return {
          ...column,
          render: (_, rowData) => {
            const netWeight = rowData?.netWeight;
            let value = 0;
            value =
              netWeight !== undefined && netWeight !== null
                ? primaryCalculationType === 'lal'
                  ? Number(netWeight) * 0.11664
                  : Number(netWeight) / 0.11664
                : 0;
            value = formatNumber(value, 3);
            return isNaN(value) ? 0 : value;
          },
        };

      // case 'rate':
      //   return {
      //     ...column,
      //     render: (_, rowData) => formatNumberWithComma(rowData?.rate) || 0,
      //   };
      case 'ratePerPurity':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.ratePerPurity) || 0,
        };

      case 'wastage':
        return {
          ...column,
          render: (_, rowData) => rowData?.wastageWeight || 0,
        };

      case 'pureWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.pureWeight || 0,
        };
      case 'netWithWastage':
        return {
          ...column,
          render: (_, rowData) => rowData?.netWithWastage || 0,
        };
      case 'pureWastage':
        return {
          ...column,
          render: (_, rowData) => rowData?.pureWastage || 0,
        };
      case 'receiveWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.receiveWeight || 0,
        };
      case 'finalWeight':
        return {
          ...column,
          render: (_, rowData) => rowData?.finalWeight || 0,
        };
      case 'amount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.makingAmount) || 0,
        };

      case 'netAmount':
        return {
          ...column,
          render: (_, rowData) =>
            formatNumberWithComma(rowData?.netAmount) || 0,
        };
      case 'action':
        return {
          ...column,

          className: 'tw-bg-[transparent]',

          fixed: 'right',
          width: 45,

          render: (_, rowData, index) => (
            <div className="tw-flex tw-justify-center">
              <div
                className="ant-action tw-flex"
                onClick={(e) => e.stopPropagation()}
              >
                {from !== 'purchase' && (
                  <div
                    className="ant-button-edit"
                    onClick={() => {
                      handleAddRow();
                    }}
                  >
                    <Link size="medium" className="edit">
                      <PlusOutlined />
                    </Link>
                  </div>
                )}
                {/* <div></div> */}
                <div
                  className="ant-button-delete"
                  onClick={() => {
                    if (
                      rowData?.code?.toLowerCase() ===
                      selectedRowKey?.toLowerCase()
                    ) {
                      setSelectedRowKey(null);
                    }
                    setDeleteReferenceId({
                      index,
                      id: rowData?.id || rowData?.codeWindowId,
                      item:
                        rowData?.item ||
                        rowData?.itemId ||
                        rowData?.finalData?.detailsJson[0]?.itemId,
                    });
                    setIsMessageModalVisible(true);
                  }}
                >
                  <Link size="medium" className="delete">
                    <DeleteFilled />
                  </Link>
                </div>
              </div>
            </div>
          ),
        };

      default:
        return column;
    }
  });

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e?.altKey && (e.code === 'ArrowUp' || e.code === 'Home')) {
        e.preventDefault();
        if (firstRowRef.current) {
          firstRowRef.current.focus();
        }
      } else if (e?.altKey && (e.code === 'ArrowDown' || e.code === 'End')) {
        e.preventDefault();
        if (lastRowRef.current) {
          lastRowRef.current.focus();
        }
      } else if (e.code === 'ArrowRight') {
        requestAnimationFrame(() => {
          noRef?.current?.focus();
        });
      } else if (e.code === 'ArrowLeft') {
        requestAnimationFrame(() => {
          yesRef?.current?.focus();
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const state = location?.state || null;

  const { ledgerDetails, stockDetails, setLedgerDetails } =
    useTransactionContext();

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const exclude = [
    '/codewindow',
    '/sales/return/code/window',
    '/purchase/return/code/window',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/ledger-details/reports/',
    '/stock/detail/report/',
    '/stock/ledger/report/',
    '/ledger/reports/',
    '/stock-summary/reports/',
  ];

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const target = isExcluded
    ? null
    : [...history]
        .reverse()
        .find(
          (path, index) =>
            index === 1 &&
            returnLinks?.some((prefix) => path.startsWith(prefix)),
        );

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) =>
      item?.route === location?.pathname ||
      location?.pathname.startsWith(item.route),
  )?.route_to_redirect;

  return (
    <>
      <DraggableModal
        open={yesNo}
        onCancel={() => setYesNo(false)}
        width={400}
        title={'Are you sure you want to exit?'}
        footer={
          <div className="tw-flex tw-justify-end tw-gap-x-3">
            <div>
              <AntButton
                ref={yesRef}
                onClick={() => {
                  target
                    ? navigate(target, {
                        state: {
                          ...stateData,
                        },
                      })
                    : isRedirectPath
                      ? navigate(isRedirectPath, {
                          state: {
                            ...stateData,
                          },
                        })
                      : navigate(-1);
                }}
              >
                Yes
              </AntButton>
            </div>
            <div>
              <AntButton
                color="red"
                ref={noRef}
                onClick={() => {
                  setYesNo(false);
                }}
              >
                No
              </AntButton>
            </div>
          </div>
        }
      ></DraggableModal>

      <Table
        bordered
        loading={loading}
        columns={modifiedColumns}
        onRow={(rowData, index) => {
          return {
            tabIndex: index,
            ref:
              index === 0
                ? firstRowRef
                : index === tableData.length - 1
                  ? lastRowRef
                  : null,
            onClick: () => {
              if (rowData?.item || rowData?.itemName) {
                setSelectedRowKey(rowData?.code);
                if (enableDiamondStone && isDiamondStoneRow(rowData)) {
                  openDiamondStoneForRow(rowData);
                  return;
                }
                navigate(`/${editUrl}/${rowData?.id || rowData?.codeWindowId}`);
              }
            },
            onKeyDown: (e) => {
              try {
                if (e.key === 'ArrowUp' && index > 0) e.preventDefault();
                e.target.previousSibling.focus();
                if (e.key === 'ArrowDown' && index < tableData?.length)
                  e.preventDefault();
                e.target.nextSibling.focus();
              } catch (err) {}
            },
          };
        }}
        rowClassName={(record) =>
          selectedRowKey &&
          record?.code?.toLowerCase() === selectedRowKey.toLowerCase()
            ? 'tw-bg-[#d9fdd3] selectedRow tw-cursor-pointer'
            : record?.grossWeight
              ? '!tw-cursor-pointer'
              : 'selectedRow'
        }
        dataSource={tableData}
        style={{ textAlign: 'center', padding: '0 15px' }}
        pagination={false}
        scroll={{
          x: 'max-content',
          y: purchaseTableData?.length > 1 ? '22.5vh' : scrollY,
        }}
        summary={() => renderSummary}
      />
      <GlobalModal
        isVisible={isMessageModalVisible}
        type={'delete'}
        onConfirm={() => {
          handlePurchaseItemClick(
            deletereferenceId?.id,
            deletereferenceId.item,
            setIsMessageModalVisible,
          );
        }}
        onClose={() => {
          setIsMessageModalVisible(false);
        }}
      />
      <GlobalFormModal
        title="Create Item"
        isVisible={isModalVisible}
        onClose={() => {
          closeModal();
        }}
      >
        <ItemForm
          onClose={() => {
            closeModal();
          }}
          refreshTable={refreshTable}
        />
      </GlobalFormModal>
    </>
  );
};

export default DynamicTransactionTableSO;
